/* global REACT_APP_PUBLIC_FEATURE_FLAGS */
const flags: string[] = typeof REACT_APP_PUBLIC_FEATURE_FLAGS !== 'undefined' ? REACT_APP_PUBLIC_FEATURE_FLAGS : [];

export const ENABLE_ORDERS_V2 = flags.includes('orders-v2');
export const ENABLE_COMMERCE_V2 = flags.includes('commerce-v2');
export const ENABLE_DELIVERY_V2 = flags.includes('delivery-v2');
export const ENABLE_HORARIOS_V2 = flags.includes('horarios-v2');
export const ENABLE_AJUSTES_V2 = flags.includes('ajustes-v2');
export const ENABLE_MENU_V2 = flags.includes('menu-v2');
export const ENABLE_STATS_V2 = flags.includes('stats-v2');
// FR-28: ON → selector (ActivatePlanModal); OFF → Payment Link viejo.
export const ENABLE_PAYMENT_SELECTOR_V2 = flags.includes('payment-selector-v2');
// Reception gate (multisucursal): cuando está ON, el FE envía identidad de la conexión
// (id_comercio + can_see_other_branches) en el subscribe para que el backend pueda filtrar
// eventos por comercio. Default OFF: el mensaje de subscribe queda idéntico al actual
// (solo channelIds) y NO se altera la recepción de pedidos/tickets de ningún perfil.
export const ENABLE_RECEPTION_GATE = flags.includes('reception-gate');
